import { Box, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { ICommonDatagridProps } from '../../../types/commonDatagrid';

export const CompactPhoneDatagrid = ({
  data,
  columns,
  rowId,
  footer,
}: Pick<ICommonDatagridProps, 'data' | 'columns' | 'rowId' | 'footer'>) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm')); // phone

  return (
    <>
      <Box>
        <Box
          sx={{
            width: '100%',
            overflowX: 'auto',
            WebkitOverflowScrolling: 'touch',
            mt: 2,
          }}
        >
          <DataGrid
            getRowId={(row) => row[rowId]}
            rows={data}
            columns={columns}
            autoHeight
            hideFooter
            density="compact"
            disableColumnMenu
            disableColumnSorting
            getRowHeight={() => 'auto'}
            columnHeaderHeight={50}
            rowHeight={40}
            sx={{
              width: '100%', // stretch full width on desktop
              minWidth: isSmall ? 'max-content' : '100%', // allow shrink + scroll on mobile
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              '& .MuiDataGrid-columnHeaderTitle': {
                fontSize: 12,
                fontWeight: 600,
                whiteSpace: 'normal',
                lineHeight: 1.1,
                textAlign: 'center',
              },

              '& .MuiDataGrid-cell': {
                padding: '4px 6px',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                lineHeight: 1.3,
                display: 'flex',
                alignItems: 'center',
              },

              '& .MuiDataGrid-row:nth-of-type(odd)': {
                backgroundColor: '#fafafa',
              },
            }}
          />
        </Box>
        {footer ? (
          <>
            <Divider />
            <Box
              sx={{
                px: 1,
                py: 0.75,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontSize: 12,
                backgroundColor: '#fafafa',
                borderLeft: '1px solid',
                borderRight: '1px solid',
                borderBottom: '1px solid',
                borderColor: 'divider',
                borderBottomLeftRadius: 4,
                borderBottomRightRadius: 4,
              }}
            >
              {footer}
            </Box>
          </>
        ) : (
          <></>
        )}
      </Box>
    </>
  );
};
